import { getTenant } from '../../../theme/tokens'
import { Bill } from '../../../shared/types/Bill'
export const mockBills: Bill[] = [
  {
    id: '1',
    billNumber: 'INV-2026-001',
    supplierId: '1',
    supplierName: 'Test Company Limited',
    supplierEmail: 'simon+supplier@maybank.com.my',
    supplierPhone: '021234567',
    amount: 9393,
    currency: getTenant().currency.code,
    status: 'pending_approval',
    dueDate: '2026-04-13',
    issueDate: '2026-03-13',
    description: 'Monthly service fee',
    items: [
      {
        id: '1',
        description: 'Service fee - March',
        quantity: 1,
        unitPrice: 9393,
        total: 9393,
      },
    ],
    subtotal: 9393,
    total: 9393,
    approvalStatus: 'pending',
    financingStatus: 'not_requested',
    createdBy: 'Simon Verraest',
    attachmentFileName: 'invoice_march_2026.pdf',
  },
  {
    id: '2',
    billNumber: 'INV-2026-002',
    supplierId: '5',
    supplierName: 'KL Fresh Produce Sdn. Bhd.',
    supplierEmail: 'procurement@siamfresh.co.th',
    supplierPhone: '023456789',
    amount: 128500,
    currency: getTenant().currency.code,
    status: 'pending_approval',
    dueDate: '2026-04-20',
    issueDate: '2026-03-10',
    description: 'Fresh produce - March delivery',
    items: [
      {
        id: '1',
        description: 'Organic vegetables',
        quantity: 50,
        unitPrice: 1500,
        total: 75000,
      },
      {
        id: '2',
        description: 'Fresh fruits',
        quantity: 25,
        unitPrice: 2140,
        total: 53500,
      },
    ],
    subtotal: 128500,
    total: 128500,
    approvalStatus: 'pending',
    financingStatus: 'not_requested',
  },
  {
    id: '3',
    billNumber: 'INV-2026-003',
    supplierId: '3',
    supplierName: 'Packaging Solutions Co., Ltd.',
    supplierEmail: 'john@packagingsolutions.th',
    supplierPhone: '027778899',
    amount: 45000,
    currency: getTenant().currency.code,
    status: 'approved',
    dueDate: '2026-04-05',
    issueDate: '2026-03-01',
    description: 'Packaging materials - Q1',
    items: [
      {
        id: '1',
        description: 'Custom boxes (500 units)',
        quantity: 500,
        unitPrice: 90,
        total: 45000,
      },
    ],
    subtotal: 45000,
    total: 45000,
    approvalStatus: 'approved',
    approver: 'Simon Verraest',
    approvalDate: '2026-03-05',
    financingStatus: 'not_requested',
  },
  {
    id: '4',
    billNumber: 'INV-2026-004',
    supplierId: '7',
    supplierName: 'Eastern Logistics Group',
    supplierEmail: 'accounts@easternlogistics.co.th',
    amount: 67200,
    currency: getTenant().currency.code,
    status: 'approved',
    dueDate: '2026-04-15',
    issueDate: '2026-03-08',
    description: 'Freight charges - February',
    items: [
      {
        id: '1',
        description: 'Domestic freight',
        quantity: 12,
        unitPrice: 3500,
        total: 42000,
      },
      {
        id: '2',
        description: 'International shipping',
        quantity: 2,
        unitPrice: 12600,
        total: 25200,
      },
    ],
    subtotal: 67200,
    total: 67200,
    approvalStatus: 'approved',
    approver: 'Simon Verraest',
    approvalDate: '2026-03-12',
    financingStatus: 'not_requested',
  },
  {
    id: '5',
    billNumber: 'INV-2026-005',
    supplierId: '6',
    supplierName: 'Malaysian Digital Print House',
    supplierEmail: 'sales@thaidigitalprint.com',
    amount: 22750,
    currency: getTenant().currency.code,
    status: 'pending_approval',
    dueDate: '2026-04-25',
    issueDate: '2026-03-14',
    description: 'Marketing materials print run',
    items: [
      {
        id: '1',
        description: 'Brochures (1000 pcs)',
        quantity: 1000,
        unitPrice: 15,
        total: 15000,
      },
      {
        id: '2',
        description: 'Business cards (500 pcs)',
        quantity: 500,
        unitPrice: 15.5,
        total: 7750,
      },
    ],
    subtotal: 22750,
    total: 22750,
    approvalStatus: 'pending',
    financingStatus: 'not_requested',
  },
  {
    id: '6',
    billNumber: 'INV-2026-006',
    supplierId: '11',
    supplierName: 'BKK Office Supplies',
    supplierEmail: 'orders@bkkoffice.co.th',
    amount: 8450,
    currency: getTenant().currency.code,
    status: 'paid',
    dueDate: '2026-03-10',
    issueDate: '2026-02-15',
    paidDate: '2026-03-08',
    description: 'Office supplies - February',
    createdBy: 'Simon Verraest',
    attachmentFileName: 'bkk_office_feb_invoice.pdf',
    items: [
      {
        id: '1',
        description: 'Assorted office supplies',
        quantity: 1,
        unitPrice: 8450,
        total: 8450,
      },
    ],
    subtotal: 8450,
    total: 8450,
    approvalStatus: 'approved',
    approver: 'Simon Verraest',
    approvalDate: '2026-02-20',
    financingStatus: 'not_requested',
    paymentSource: 'balance',
    payoutType: 'bank_account',
  },
  {
    id: '7',
    billNumber: 'INV-2026-007',
    supplierId: '15',
    supplierName: 'Metro Clean Services',
    supplierEmail: 'billing@metroclean.co.th',
    amount: 18900,
    currency: getTenant().currency.code,
    status: 'paid',
    dueDate: '2026-03-01',
    issueDate: '2026-02-01',
    paidDate: '2026-02-28',
    description: 'Cleaning services - February',
    createdBy: 'Simon Verraest',
    items: [
      {
        id: '1',
        description: 'Monthly cleaning contract',
        quantity: 1,
        unitPrice: 18900,
        total: 18900,
      },
    ],
    subtotal: 18900,
    total: 18900,
    approvalStatus: 'approved',
    approver: 'Simon Verraest',
    approvalDate: '2026-02-05',
    financingStatus: 'not_requested',
    paymentSource: 'card',
    payoutType: 'bank_account',
  },
  {
    id: '8',
    billNumber: 'INV-2026-008',
    supplierId: '13',
    supplierName: 'Northern Textile Mills',
    supplierEmail: 'sales@northerntextile.co.th',
    amount: 89300,
    currency: getTenant().currency.code,
    status: 'pending_approval',
    dueDate: '2026-05-01',
    issueDate: '2026-03-15',
    description: 'Textile order - Spring collection',
    items: [
      {
        id: '1',
        description: 'Cotton fabric (200m)',
        quantity: 200,
        unitPrice: 350,
        total: 70000,
      },
      {
        id: '2',
        description: 'Silk blend (50m)',
        quantity: 50,
        unitPrice: 386,
        total: 19300,
      },
    ],
    subtotal: 89300,
    total: 89300,
    approvalStatus: 'pending',
    financingStatus: 'not_requested',
  },
  {
    id: '9',
    billNumber: 'INV-2026-009',
    supplierId: '10',
    supplierName: 'Andaman Seafood Export',
    supplierEmail: 'export@andamanseafood.com',
    amount: 234100,
    currency: getTenant().currency.code,
    status: 'approved',
    dueDate: '2026-04-10',
    issueDate: '2026-03-05',
    description: 'Seafood export - March batch',
    items: [
      {
        id: '1',
        description: 'Premium shrimp (500kg)',
        quantity: 500,
        unitPrice: 320,
        total: 160000,
      },
      {
        id: '2',
        description: 'Fresh fish (300kg)',
        quantity: 300,
        unitPrice: 247,
        total: 74100,
      },
    ],
    subtotal: 234100,
    total: 234100,
    approvalStatus: 'approved',
    approver: 'Simon Verraest',
    approvalDate: '2026-03-10',
    financingStatus: 'not_requested',
  },
  {
    id: '10',
    billNumber: 'INV-2026-010',
    supplierId: '17',
    supplierName: 'Isaan Rice Trading',
    supplierEmail: 'trade@isaanrice.co.th',
    amount: 156000,
    currency: getTenant().currency.code,
    status: 'approved',
    dueDate: '2026-03-30',
    issueDate: '2026-02-28',
    description: 'Jasmine rice - March shipment',
    items: [
      {
        id: '1',
        description: 'Jasmine rice (10 tons)',
        quantity: 10,
        unitPrice: 15600,
        total: 156000,
      },
    ],
    subtotal: 156000,
    total: 156000,
    approvalStatus: 'approved',
    approver: 'Simon Verraest',
    approvalDate: '2026-03-02',
    financingStatus: 'not_requested',
  },
  {
    id: '11',
    billNumber: 'INV-2026-011',
    supplierId: '18',
    supplierName: 'Rayong Rubber Industries',
    supplierEmail: 'procurement@rayongrubber.co.th',
    amount: 312500,
    currency: getTenant().currency.code,
    status: 'pending_approval',
    dueDate: '2026-05-15',
    issueDate: '2026-03-14',
    description: 'Rubber materials - Q2 order',
    items: [
      {
        id: '1',
        description: 'Natural rubber sheets',
        quantity: 100,
        unitPrice: 2500,
        total: 250000,
      },
      {
        id: '2',
        description: 'Synthetic rubber',
        quantity: 50,
        unitPrice: 1250,
        total: 62500,
      },
    ],
    subtotal: 312500,
    total: 312500,
    approvalStatus: 'pending',
    financingStatus: 'not_requested',
  },
  {
    id: '12',
    billNumber: 'INV-2026-012',
    supplierId: '8',
    supplierName: 'Nattaya Suwannapoom',
    supplierEmail: 'nattaya.s@hotmail.com',
    amount: 15000,
    currency: getTenant().currency.code,
    status: 'paid',
    dueDate: '2026-03-15',
    issueDate: '2026-02-20',
    paidDate: '2026-03-14',
    description: 'Freelance design work - February',
    items: [
      {
        id: '1',
        description: 'UI/UX design services',
        quantity: 1,
        unitPrice: 15000,
        total: 15000,
      },
    ],
    subtotal: 15000,
    total: 15000,
    approvalStatus: 'approved',
    approver: 'Simon Verraest',
    approvalDate: '2026-02-25',
    financingStatus: 'not_requested',
    paymentSource: 'balance',
    payoutType: 'promptpay',
  },
  {
    id: '13',
    billNumber: 'INV-2026-013',
    supplierId: '19',
    supplierName: 'Krabi Tour Operators',
    supplierEmail: 'finance@krabitours.com',
    amount: 41600,
    currency: getTenant().currency.code,
    status: 'approved',
    dueDate: '2026-04-30',
    issueDate: '2026-03-12',
    description: 'Corporate retreat arrangements',
    items: [
      {
        id: '1',
        description: 'Tour packages (20 pax)',
        quantity: 20,
        unitPrice: 1500,
        total: 30000,
      },
      {
        id: '2',
        description: 'Transport & logistics',
        quantity: 1,
        unitPrice: 11600,
        total: 11600,
      },
    ],
    subtotal: 41600,
    total: 41600,
    approvalStatus: 'approved',
    approver: 'Simon Verraest',
    approvalDate: '2026-03-14',
    financingStatus: 'not_requested',
  },
  {
    id: '14',
    billNumber: 'INV-2026-014',
    supplierId: '9',
    supplierName: 'Green Valley Agriculture',
    supplierEmail: 'info@greenvalleyag.co.th',
    amount: 52000,
    currency: getTenant().currency.code,
    status: 'pending_approval',
    dueDate: '2026-04-18',
    issueDate: '2026-03-15',
    description: 'Organic fertilizer supply',
    items: [
      {
        id: '1',
        description: 'Organic fertilizer (2 tons)',
        quantity: 2,
        unitPrice: 26000,
        total: 52000,
      },
    ],
    subtotal: 52000,
    total: 52000,
    approvalStatus: 'pending',
    financingStatus: 'not_requested',
  },
  {
    id: '15',
    billNumber: 'INV-2026-015',
    supplierId: '12',
    supplierName: 'Piyawat Sricharoen',
    supplierEmail: 'piyawat.sri@gmail.com',
    amount: 3200,
    currency: getTenant().currency.code,
    status: 'paid',
    dueDate: '2026-03-05',
    issueDate: '2026-02-10',
    paidDate: '2026-03-04',
    description: 'Photography services',
    items: [
      {
        id: '1',
        description: 'Product photography session',
        quantity: 1,
        unitPrice: 3200,
        total: 3200,
      },
    ],
    subtotal: 3200,
    total: 3200,
    approvalStatus: 'approved',
    approver: 'Simon Verraest',
    approvalDate: '2026-02-15',
    financingStatus: 'not_requested',
    paymentSource: 'bank_transfer',
    payoutType: 'bank_account',
  },
]

// Helper to update a single bill in the mock data
export function updateBill(
  billId: string,
  updates: Partial<import('../../../shared/types/Bill').Bill>,
) {
  const index = mockBills.findIndex((b) => b.id === billId)
  if (index !== -1) {
    mockBills[index] = {
      ...mockBills[index],
      ...updates,
    }
  }
}

// Schedule bills: set approver, keep status as pending_approval
export function scheduleBills(
  billIds: string[],
  assignments: Record<
    string,
    {
      approver: string
      paymentMethod: string
      paymentDate: string
    }
  >,
) {
  billIds.forEach((id) => {
    const assignment = assignments[id]
    if (!assignment) return
    const approver =
      assignment.approver === 'auto' ? undefined : assignment.approver
    updateBill(id, {
      status: 'pending_approval',
      approvalStatus: 'pending',
      approver: approver,
    })
  })
}

// Approve a bill (single approval step)
export function approveBill(billId: string, approverName: string) {
  updateBill(billId, {
    status: 'approved',
    approvalStatus: 'approved',
    approver: approverName,
    approvalDate: new Date().toISOString().split('T')[0],
  })
}

// Reject a bill
export function rejectBill(
  billId: string,
  approverName: string,
  notes?: string,
) {
  updateBill(billId, {
    status: 'rejected',
    approvalStatus: 'rejected',
    approver: approverName,
    approvalDate: new Date().toISOString().split('T')[0],
    approvalNotes: notes,
  })
}
